// This action follow the Flux Standard Action (FSA) convention.

interface ActionTypeRequest {
  type: string;
  meta?: any;
}

interface ActionTypeSuccess {
  type: string;
  payload?: any;
  meta?: any;
}

interface ActionTypeFailure {
  type: string;
  payload?: any;
  meta?: any;
  error?: boolean | null;
}

export interface ActionType {
  type: string;
  payload?: any;
  meta?: any;
  error?: boolean | null;
}

export const requestActionCreator = ({ type, meta }: ActionTypeRequest) => {
  return {
    type,
    meta,
  };
};

export const successActionCreator = ({
  type,
  payload,
  meta,
}: ActionTypeSuccess) => {
  return {
    type,
    payload,
    meta,
  };
};

export const failureActionCreator = ({
  type,
  payload,
  meta,
  error = true,
}: ActionTypeFailure) => {
  return {
    type,
    payload,
    meta,
    error,
  };
};
